(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    const body = document.body;
    if (!body || !body.classList.contains('fa-liquid-glass')) return;

    const desktopHeader = window.matchMedia('(min-width: 990px)');
    let headerCollapsed = false;
    let ticking = false;

    const clearHeaderState = () => {
      body.classList.remove('site-header-shrink-ready', 'site-header-shrink-collapsed');
      headerCollapsed = false;
    };

    const syncHeaderState = () => {
      if (!desktopHeader.matches) {
        clearHeaderState();
        return;
      }

      body.classList.add('site-header-shrink-ready');

      const y = window.scrollY || window.pageYOffset || 0;
      const collapseAt = 56;
      const expandAt = 16;

      if (!headerCollapsed && y > collapseAt) {
        headerCollapsed = true;
        body.classList.add('site-header-shrink-collapsed');
      } else if (headerCollapsed && y < expandAt) {
        headerCollapsed = false;
        body.classList.remove('site-header-shrink-collapsed');
      }
    };

    const queueUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        syncHeaderState();
        ticking = false;
      });
    };

    syncHeaderState();
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);
    window.addEventListener('load', queueUpdate);

    if (typeof desktopHeader.addEventListener === 'function') {
      desktopHeader.addEventListener('change', queueUpdate);
    } else if (typeof desktopHeader.addListener === 'function') {
      desktopHeader.addListener(queueUpdate);
    }
  });
})();
